import './prototypes';
import { WbBarbaController } from './modules/WbBarbaController';
import { WbScrollTo } from './modules/WbScrollTo';
import { WbPrintController } from './modules/WbPrintController';
import { WbBackToTop } from './modules/WbBackToTop';
import { WbSliders } from './modules/WbSliders';
import { WbMasthead } from './modules/WbMasthead';
import { WbForm } from './modules/WbForm';
import { WbVideo } from './modules/WbVideo';
import { WbAccordion } from './modules/WbAccordion';
import { WbTabs } from './modules/WbTabs';
import { WbAnimations } from './modules/WbAnimations';
import { WbCommerce } from './modules/WbCommerce';
import { WbSearchController } from './modules/WbSearchController';
import { WbCyberimpact } from './modules/WbCyberimpact';
import { WbPikaday } from './modules/WbPikaday';
import { WbPopper } from './modules/WbPopper';
import { WbMap } from './modules/WbMap';
import { WbMarkersMap } from './modules/WbMarkersMap';

import { WbGoogleTranslate } from './modules/WbGoogleTranslate';
import { WbPdfBook } from './modules/WbPdfBook';

document.addEventListener('readystatechange', event => {
  if (document.readyState == 'complete') {
    /**
     * ALL OF THESE ARE GLOBALS
     * DO NOT IMPORT IN A DIFFERENT MODULE
     */
    window.WbBarbaController = new WbBarbaController();
    window.WbScrollTo = new WbScrollTo();
    window.WbPrintController = new WbPrintController();
    window.WbBackToTop = new WbBackToTop();
    window.WbMasthead = new WbMasthead();
    window.WbTabs = new WbTabs();
    window.WbAnimations = new WbAnimations();
    window.WbCommerce = new WbCommerce();
    window.WbSearchController = new WbSearchController();
    window.WbCyberimpact = new WbCyberimpact();

    window.WbGoogleTranslate = new WbGoogleTranslate();

    window.WbBarbaController.addObject(window.WbScrollTo);
    window.WbBarbaController.addObject(window.WbCommerce);
    window.WbBarbaController.addObject(new WbAccordion());
    window.WbBarbaController.addObject(new WbMap());
    window.WbBarbaController.addObject(new WbSliders());
    window.WbBarbaController.addObject(new WbForm());
    window.WbBarbaController.addObject(new WbVideo());
    window.WbBarbaController.addObject(new WbPikaday());
    window.WbBarbaController.addObject(new WbPopper());
    window.WbBarbaController.addObject(new WbMarkersMap());
    window.WbBarbaController.addObject(new WbPdfBook());

    window.WbBarbaController.init();
  }
});
